module.exports = __webpack_public_path__ + "assets/img/xietong.f16601f8.svg";